<div class="greenness-notification" [class.web-app]="webApp">
  <div class="greenness-header">
    <app-ds-icon color="var(--color-core-neutral-10)" [name]="success ? 'MessageCircleHeart' : 'CircleX' "
                 [size]="webApp ? 'icon-size-5' : 'icon-size-3'"></app-ds-icon>
    <h1 [ngClass]="webApp ? 'ds-title-3' : 'ds-heading-1'">
      {{ (success ? 'GREENNESS.surveySuccess.title' : 'GREENNESS.surveyFailure.title') | translate }}
    </h1>
  </div>
  <p class="ds-running-2">{{ (success ? 'GREENNESS.surveySuccess.description' : 'GREENNESS.surveyFailure.description') | translate }}</p>
  <app-ds-button [size]="webApp ? 'default' : 'small'" variant="primary" width="auto" (clicked)="closeNotification.emit()">
    {{ 'GREENNESS.surveySuccess.closeButton' | translate }}
  </app-ds-button>
</div>
